import axios from 'axios';
import { getAuthToken } from '../services/auth';
import baseUrl from '../config/baseURL';

export const getInstagramComments = async (
  organization_id: any,
  account_id: any,
  nextUrl: any = null,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = nextUrl
          ? nextUrl
          : `${baseUrl}/core/organizations/${organization_id}/instagram-comments/`;

        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed:', response);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('Unexpected API error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};

export const replyToInstagramComment = async (
  organization_id: any,
  account_id: any,
  comment_id: any,
  text: string,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-comments/${comment_id}/reply/`;
        const response = await axios.post(endpoint, { text }, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected reply error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};

// export const replyToInstagramComment = async (
//   org_id: string,
//   parent_comment_id: string,
//   text: string,
// ) => {
//   let token = await getAuthToken();

//   if (!token) {
//     return { success: false, data: 'Token does not exist' };
//   }

//   const header_token = `Bearer ${token.data}`;
//   const headers = { Authorization: header_token };

//   const endpoint = `${baseUrl}/core/instagram/comments/reply/`;

//   const payload = {
//     org_id,
//     parent_comment_id,
//     text,
//   };

//   console.log('➡️ Sending IG comment reply');
//   console.log('➡️ Endpoint:', endpoint);
//   console.log('➡️ Payload:', payload);

//   try {
//     const response = await axios.post(endpoint, payload, { headers });

//     return {
//       success: response.status >= 200 && response.status < 300,
//       data: response.data,
//     };
//   } catch (error: any) {
//     console.error('🔥 IG Reply Error:', error);

//     if (error.response) {
//       return {
//         success: false,
//         data: error.response.data,
//         status: error.response.status,
//       };
//     }

//     return { success: false, data: 'Network or unknown error' };
//   }
// };

export const deleteInstagramComment = async (
  organization_id: any,
  account_id: any,
  comment_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/organizations/core/${organization_id}/instagram-comments/${comment_id}/`;
        const response = await axios.delete(endpoint);

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected reply error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};

export const toggleInstagramAiCommentResponses = async (
  organization_id: any,
  account_id: any,
  enabled: boolean,
) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/instagram-account/${account_id}/toggle-ai-comments/`;
        const response = await axios.post(endpoint, { enabled }, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected error (toggle comment AI):', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};
